
import React from 'react';
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
import cIf from 'classnames';
import { find, findIndex, map, filter, sortBy, head, includes } from 'lodash';

import { useBaseSiteStore, useAddTicketsToCartStore, AddTicketsToCartStore } from '../../../stores';

// Components
import { MembershipCardPickupControl } from '../../organisms/memberships';
import { EventInfo, ProgramInfo, SaleMessagesInfo, ProductOverview, PrepaidCardQtySelection, MembershipCardPurchaseButtons } from '../../organisms/buytickets';
import { PromoPasswordInputPanel, PromoSelectorButtons } from '../../organisms/promotions';
import { ScheduleRangeSelector, ScheduleRangeSelectorInfo } from 'ts-common-react-controls';
import { RCOMBRIDGE_getURLToClientSite, RCOMBRIDGE_getClientSiteURLParams, testIFrameCookieSecurityIssue, CookieSecurityWarningPanel, retrieveIFramePosition,
    PleaseWaitSpinner, PageSection } from '../../../../jsxctl/utilctl';
import { TicketSelection } from '../../organisms/selecttickets';
import { TicketPriceSelection } from '../../organisms/selectprices';



// Types
import { EventDateInfo } from '../../../mvcapi/models/common';
import { Section } from '../../../mvcapi/models/buyticket';
import { PlaceToGoEnum } from '../../organisms/buytickets/types';

// Utils
import tsRest from 'ts-rest-client';
import { getMomentTZDateTime } from 'ts-util';

import TranslateManager from 'ts-translate-js';
import { LiteShopProductOverview } from '../../molecules/buytickets/lite-shop-product-overview';
import { TicketSelectionUnrestricted } from '../../organisms/buytickets/ticket-selection-unrestricted';
import { IFrameContext, IFrameContextClass } from '../../../logic/reactcontext/iframe-context';
import { CacheStoreContext, CacheStoreContextClass } from '../../../logic/reactcontext/cache-store-context';
import { SiteCustomizationClass, SiteCustomizationContext } from '../../../logic/reactcontext/site-customization-context';
import { CreateReactClassComponent } from '../../../types/createreactapp';
import { EventInfo as EventInfoModel } from '../../../mvcapi/models/common/eventinfo';
import { MembershipTypeSaleInfoModel } from '../../../tsrestapi/models';
import { BuyTicketPromoInfoModel } from '../../../mvcapi/models/buyticket/buy-ticket-promo-info-model';
import { AutoFindTicketModel } from '../../../logic/models';
import { trackItemView } from '../../../logic/tracking-logic';
import { StateWatcher } from '../../../stores/store-utils';
import { trackEcommerceEvent } from '../../../../js/client-tracking';

const MarkDown = require("react-markdown");
const tr = TranslateManager.boundTR;

const cacheStore = new CacheStoreContextClass();

// const ctl = tsapp.ctl;
// TODO : EventNotInSaleCustomMessage devra Ãªtre ajouter pour RESERVATECH.NET
// TODO : CanShowAdditionalDateNotificationListEnabled

const steps = [
    'SELECTDATE',
    'VALIDPROMO',
    'SELECTTICKET',
    'SELECTPRICE'
];

const _ThresholdMinSite = 400;


type BuyTicketOnePagerWidgetProps = {
    programID?: string;
    eventID?: number; // If not null, works by event instead of program
    eventDateID: number; // If not null, radically switch to event date mode
    preferredSelectedEventDateID?: number; // This gives the opportunity to the caller to pre-select a specific date in program mode.
    preferredSelectedSectionId: number; // If not null, will select this section by default
    rstprv?: string;
    continueShoppingUrl?: string;
    hideBestTicketSelection: boolean;
    onContentChange?: () => void;
}

type BuyTicketOnePagerWidgetState = {
    eventDateID: number; // Selected event date id
    eventDate: EventDateInfo; // All info about an event date
    currentStep: string;
    processing: boolean;
    loadingEventInfo: boolean;
    loadingProgram: boolean;
    loadingProductInfo: boolean; // The selected product
    loadingPromoInfo: boolean; // The selected promo
    SuggestedQtySales: number;
    program: any;
    currentError: string;
    iframeCookieIssue: boolean; // This is a check for Safari, IPhone, IPads because these browsers don't allow settings cookies when the user hasn't visited our main web site using no IFrame.
    packageUrl: string;
    siteInfo: any;
    urlClientSite: string;
    sectionIDAutoFindTicket: number;
    scheduleRange: any;
    minHeight: number;
    framePosition: { x: number, y: number };
    cookiesVerified: boolean;
    autoFindTicket: AutoFindTicketModel;
    promoInfo: BuyTicketPromoInfoModel;
    eventInfo: EventInfoModel;
    showMembercardPopup: boolean;
    showPromoSelector: boolean;
    membershipTypeInfos: MembershipTypeSaleInfoModel[];
}

// interface BuyTicketOnePagerWidgetInterface {
//     watchState: <T>(get: (AddTicketsToCartStore) => T, set: (BuyTicketOnePagerWidgetState, val: T) => void) => void;
// }

// Julie : eu le tmeps de checker pour le 3$ de poste, pareil au montant total du coupon client. Pas été jusqu'à l'affichage.
   
type BuyTicketOnePagerWidgetInterface = CreateReactClassComponent<typeof BuyTicketOnePagerWidgetDef, BuyTicketOnePagerWidgetProps, BuyTicketOnePagerWidgetState>;



// Convertir en Component pour faire disparaitre l'erreur eslint mais pour le moment ça n'empêche pas de builder
const BuyTicketOnePagerWidgetDef = {
    displayName: "BuyTicketOnePagerWidget",

    iframeContext: null,

    //unsubsribes: [],
    addToCartStoreWatcher: null as StateWatcher<AddTicketsToCartStore, BuyTicketOnePagerWidgetState>,

    packagePromoContainerRef: null,

    // Load de l'info de salle, affichage du "À telle place"
    // Load du contact panel, affichage des nummÃ©ros de tel
    // Peut-È©tre conversion du combo en drop down mais pas tout de suite

    propTypes: {
        programID: PropTypes.string,
        eventID: PropTypes.number, // If not null, works by event instead of program
        eventDateID: PropTypes.number, // If not null, radically switch to event date mode
        preferredSelectedEventDateID: PropTypes.number, // This gives the opportunity to the caller to pre-select a specific date in program mode.
        preferredSelectedSectionId: PropTypes.number, // If not null, will select this section by default
        rstprv: PropTypes.string,
        continueShoppingUrl: PropTypes.string.isRequired,
        hideBestTicketSelection: PropTypes.bool,
        onContentChange: PropTypes.func,
        //siteSettings: PropTypes.any,
    },

    getInitialState() {
        return {
            eventDateID: 0, // Selected event date id
            eventDate: null, // All info about an event date
            currentStep: 'SELECTDATE',
            processing:false,
            loadingProgram: false,
            loadingProductInfo: false, // The selected product
            loadingPromoInfo: false, // The selected promo
            SuggestedQtySales: 0,
            program: null,
            currentError: null,
            iframeCookieIssue: testIFrameCookieSecurityIssue(), // This is a check for Safari, IPhone, IPads because these browsers don't allow settings cookies when the user hasn't visited our main web site using no IFrame.
            packageUrl: null,
            siteInfo: null,
            urlClientSite: null,
            sectionIDAutoFindTicket: null,
            scheduleRange: null,
            minHeight: 0, // Used by the popup compensation system for IFrame resize. When a sub popup is bigger than the main app Div.
        };
    },
    
    /**
     * 
     * @returns {{eventDateID: number | null, preferredSelectedSectionId: number, hideBestTicketSelection: boolean}}
     */
    getDefaultProps() {
        return {
            eventDateID: null,
            preferredSelectedSectionId: 0,
            hideBestTicketSelection: false,
            //siteSettings: null
        };
    },

    // watchState<T>(get: (_s: AddTicketsToCartStore) => T, set: (_val: T) => Partial<BuyTicketOnePagerWidgetState>) {
    //     const _this: BuyTicketOnePagerWidgetInterface = this;
    //     _this.unsubsribes.push(useAddTicketsToCartStore.subscribe(s => get(s), (val) => { _this.setState(() => set(val)); }));
    // },

    componentDidMount() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.addToCartStoreWatcher = new StateWatcher<AddTicketsToCartStore, BuyTicketOnePagerWidgetState>(useAddTicketsToCartStore, this.setState.bind(this));
        let iframeContext = new IFrameContextClass();
        _this.iframeContext = iframeContext;
        const siteSettingsContext = new SiteCustomizationClass(tsapp.siteSettings);
        this.siteSettingsContext = siteSettingsContext;

        // Init base store stuff. This could go in the TS App Init instead
        useBaseSiteStore.getState().setInteg(this.props.integ);

        // If we keep doing it with selectors, we should push all of these unsubsribes in an array.
        _this.addToCartStoreWatcher.addUnsubscribe(useAddTicketsToCartStore.subscribe(s => s.eventDate, _this.onNewEventDateLoaded));
        //_this.watchState(s => s.loadingError, (v) => ({ currentError: v} ));
        _this.addToCartStoreWatcher.watch('loadingError', 'currentError');
        
        useAddTicketsToCartStore.getState().setAfterAddedToCartCallback(_this.onProductAddedToCart);
        useAddTicketsToCartStore.getState().setOnPromoUpdatedCallback(_this.handlePromoUpdated);
        useAddTicketsToCartStore.getState().setPreferredSelectedSectionId(_this.props.preferredSelectedSectionId);
        useAddTicketsToCartStore.getState().setOnFindTicketsWhenNoPriceCallback(_this.onFindTicketsWhenNoPrice);
        
        if(_this.props.onContentChange) {
            iframeContext.onContentChanged(this.props.onContentChange);
            iframeContext.onMinSizeChanged(this.minSizeRequested);
        }

        //RCOMBRIDGE_copyTrackingCookies();
        _this.setCookiesVerified();

        //// Load the urls for this integration
        //_this.urlsProm = tsRest.get("/integration/" + _this.props.integ + "/urls");

        _this.setReturnToPackageUrl();

        
        _this.packagePromoContainerRef = React.createRef();

        if(_this.props.rstprv != null && _this.props.rstprv.length > 0)
            _this.loadPromoInfo();

        if(_this.props.eventDateID != null) {
            _this.setState({ eventDateID: _this.props.eventDateID });
            _this.buyEventDate(_this.props.eventDateID);
        }

        if(_this.props.eventID != null)
            _this.loadEventItemInfos(true);
        else if(_this.props.programID != null)
            _this.loadProgramItemInfos(true);


        retrieveIFramePosition("sticky-menu", _this.setIFramePosition);

        _this.loadSiteInformation();

        _this.raiseContentChanged();
    },

    componentDidUpdate() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        const hiddenPromo = (_this.props.rstprv != null && _this.props.rstprv != "");
        if(hiddenPromo != useAddTicketsToCartStore.getState().hiddenPromo)
            useAddTicketsToCartStore.getState().setHiddenPromo(hiddenPromo);

        _this.iframeContext.onContentChange = _this.props.onContentChange;
        _this.raiseContentChanged(); // TODO : Devrait peut etre juste être triggered dans la fin du render avec un setTimeout....
    },

    componentWillUnmount () {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        //this.ajaxFeeder.abortAll();
        //this.urlsProm.abort();
        //_this.unsubsribes.forEach(unsub => unsub());
        _this.addToCartStoreWatcher.unsubscribeAll();
        if(_this.siteInfoProm) _this.siteInfoProm.abort();
        if(_this.eventInfosRequest) _this.eventInfosRequest.abort();
        if(_this.promoInfoRequest) _this.promoInfoRequest.abort();
        if(_this.eventDateInfosRequest) _this.eventDateInfosRequest.abort();
        if(_this.loadProgramRequest) _this.loadProgramRequest.abort();
        if (_this.loadPromoInfoRequest != null) _this.loadPromoInfoRequest.abort();
        if (_this.loadEventInfoRequest != null) _this.loadEventInfoRequest.abort();
        if(_this.props.onContentChange) {
            (_this.iframeContext as IFrameContextClass).offMinSizeChanged(_this.minSizeRequested);
            (_this.iframeContext as IFrameContextClass).offContentChanged(_this.onContentChange);
        }
    },

    minSizeRequested(width: number, height: number) { 
        const _this: BuyTicketOnePagerWidgetInterface = this;
        if(height != _this.state.minHeight) // Very important to prevent infinite react loop 
            _this.setState({ minHeight: height }); 
    },

    raiseContentChanged() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        // Set timeout because even though React rendered the tags, they are not yet drawn on the screen.
        setTimeout(function(){
            if(_this.props.onContentChange !== undefined) _this.props.onContentChange();
        }.bind(_this), 0);
    },

    setIFramePosition(pos) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        if(_this.state.framePosition == null || _this.state.framePosition.x != pos.x || _this.state.framePosition.y != pos.y)
            _this.setState({ framePosition: { x: pos.x, y: pos.y } });
    },

    setUrlClientSite() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        RCOMBRIDGE_getURLToClientSite((url) => _this.setState({ urlClientSite: url}));
    },
    
    getUrlParams(params) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        const cookiesVerified = params["cookiesverified"] === "true";
        if(_this.state.cookiesVerified !== cookiesVerified)
            _this.setState({ cookiesVerified: cookiesVerified });
    },
    
    setCookiesVerified() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.setUrlClientSite();
        RCOMBRIDGE_getClientSiteURLParams(_this.getUrlParams);
    },

    afterGetPositionControl(pos) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        if ((typeof window.scrollParentTo != "undefined")&& _this.state.framePosition != null && $(window).width() < _ThresholdMinSite){
            window.scrollParentTo(_this.state.framePosition.x, _this.state.framePosition.y + pos.y);
        }
    },

    handleOnFoundTickets(foundTickets) {
        const _this: BuyTicketOnePagerWidgetInterface = this;

        useAddTicketsToCartStore.getState().setAutoFindTicket(null);
        
        if(foundTickets)
            _this.setState({ autoFindTicket: null, currentStep:"SELECTPRICE" });
        else
            _this.setState({ autoFindTicket: null });

    },

    handleOnChangeEventDate(eventDateInfo, triggerBuy = false) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.setState({ eventDateID: (eventDateInfo == null) ? null : eventDateInfo.EventDateID }, () => {
            if(triggerBuy) _this.buyEventDate(eventDateInfo.EventDateID);
        });
    },

    handleOnBuyClick() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.buyEventDate(_this.state.eventDateID);
    },

    handleOnChangeScheduleRange(rangeInfo) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        if (rangeInfo){
            _this.setState({ scheduleRange: rangeInfo});            
        }
    },

    buyEventDate(eventDateID) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.loadEventDateInfo(eventDateID);
    },

    _getBestPreSelectedDateID(programItemInfos) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        // If we have a preferredSelectedEventDateID from the outside, try to find it...
        const prefDateID = _this.props.preferredSelectedEventDateID;
        let bestSelectedDate = null;

        if(_this.state.eventDateID != null) // First try to keep the item we were already on!
            // bestSelectedDate = find(programItemInfos, (pi) => pi.EventDateInfo.EventDateID === _this.state.eventDateID);
            bestSelectedDate = find(programItemInfos, ['EventDateInfo.EventDateID', _this.state.eventDateID]);

        if( bestSelectedDate == null && _this.props.preferredSelectedEventDateID != null) {// Else, preferred selection
            // bestSelectedDate = find(programItemInfos, (pi) => pi.EventDateInfo.EventDateID === prefDateID);
            bestSelectedDate = find(programItemInfos, ['EventDateInfo.EventDateID', prefDateID]);
        }

        // If we have nothing yet, find the first date in sale
        if(bestSelectedDate == null) {
            const iteminfos = sortBy(programItemInfos, 'EventDateInfo.Date');
            bestSelectedDate = find(iteminfos, 'EventDateInfo.IsInSale');
        }

        return (bestSelectedDate != null) ? bestSelectedDate.EventDateInfo.EventDateID : null;
    },

    /**
     * Loads ProgramInfos if we have a program ID
     * @param {boolean} doTrackItemView Triggers a item view in the analytics. We usualy want to do this only once per page in the componentDidMount.
     */
    loadProgramItemInfos(doTrackItemView = false) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.setState({ loadingProgram: true });
        _this.loadProgramRequest = tsapp.mvcapi.postCtl("buyticket/programiteminfos", { programID: _this.props.programID, sellerUserID: tsapp.user.ui }, { cache: false })
                                        .success(function(data) {
                                            const items = data.ProgramItemInfos;
                                            _this.setState({
                                                program: {
                                                    items: items,
                                                    prices: data.prices
                                                },
                                                loadingProgram: false,
                                                eventDateID: _this._getBestPreSelectedDateID(items)
                                            });

                                            if(doTrackItemView && items.length > 0)
                                                trackItemView(_this.siteSettingsContext.siteSettings.integ, items[0].EventDateInfo);

                                        }.bind(_this))
                                        .notSuccess(function(data) {
                                            console.error("Error while getting data : ", data);
                                            _this.setState({loadingProgram:false, currentError:data.message});
                                            _this.raiseContentChanged();
                                        }.bind(_this));
    },

    /**
     * Loads Event Info if we have an event ID
     * Ceux ci sont unifier avec le système de programmation. Comme ci un event était un programmation.
     * @param {boolean} doTrackItemView Triggers a item view in the analytics. We usualy want to do this only once per page in the componentDidMount.
     */
    loadEventItemInfos(doTrackItemView) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        if (_this.props.eventID > 0) {
            _this.setState({ loadingProgram: true });
            _this.loadProgramRequest = tsapp.mvcapi.postCtl("buyticket/eventiteminfos", { eventID: _this.props.eventID, sellerUserID: tsapp.user.ui }, { cache: false })
                                            .success(function(data) {
                                                const items = data.EventItemInfos;
                                                _this.setState({
                                                    program: {
                                                        items: items,
                                                        prices: data.prices
                                                    },
                                                    loadingProgram: false,
                                                    eventDateID: _this._getBestPreSelectedDateID(items)
                                                });

                                                if(doTrackItemView && items.length > 0)
                                                    trackItemView(_this.siteSettingsContext.siteSettings.integ, items[0].EventDateInfo);

                                            }.bind(_this))
                                            .notSuccess(function(data){
                                                console.error("Error while getting data : ", data);
                                                _this.setState({loadingProgram:false, currentError:data.message});
                                                _this.raiseContentChanged();
                                            }.bind(_this));
        }
    },

    

    loadPromoInfo() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.setState({ loadingPromoInfo: true });

        // BuyTicketPromoInfoModel
        _this.loadPromoInfoRequest = tsapp.mvcapi.postCtl("buyticket/promoinfo", { rstprv: _this.props.rstprv }, { cache: false })
                                            .success((data) => _this.handlePromoInfoUpdated(data.promoInfo));
    },

    handlePromoInfoUpdated(promoInfo: BuyTicketPromoInfoModel) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.raiseContentChanged();
        _this.setState({
            promoInfo: promoInfo,
            loadingPromoInfo: false
        });
        
        _this.promoInfoUpdated(promoInfo);
    },
    
    promoInfoUpdated(promoInfo: BuyTicketPromoInfoModel) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        // If password ok, we can load the events
        if(!promoInfo.passwordNeeded) {
            _this.loadEventInfos(promoInfo.eventID);
            // TODO Trigger the load of the event
        }
    },

    // Loads EventInfo if we have an event ID
    loadEventInfos(eventID) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.setState({ loadingEventInfo: true });
        _this.loadEventInfoRequest = tsapp.mvcapi.postCtl("buyticket/eventinfos", { eventID: eventID })
                                            .success(function(data) {
                                                const firstInSale = find(data.EventInfo.EventDateInfos, 'IsInSale');
                                                tsapp.setCurrency(firstInSale.CurrencyCode);
                                                _this.setState({
                                                    eventInfo: data.EventInfo,
                                                    loadingEventInfo: false,
                                                    eventDateID: (firstInSale != null) ? firstInSale.EventDateID : null
                                                });
                                            }.bind(_this))
                                            .notSuccess(function(data){
                                                _this.setState({loadingProductInfo:false, currentError:data.message});
                                                _this.raiseContentChanged();
                                            }.bind(_this));
      
    },

    onNewEventDateLoaded(eventDate) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        tsapp.setCurrency(eventDate.CurrencyCode);
        
        _this.setState({
            currentStep: "SELECTTICKET",
            eventDate: eventDate,
            loadingProductInfo: false
        });

        const trackingData = {
            type: 'itemSelected',
            currency: eventDate.CurrencyCode,
            items: [
                {
                    name: eventDate.ProductNameFr,
                    code: eventDate.EventDateCode,
                    producerName: eventDate.ProducerName,
                    category: eventDate.CategoryFr, // I hardcode FR here because we want it to be easy to group in analytics reports.
                    quantity: 1
                }
            ]
        };
        
        trackEcommerceEvent(_this.siteSettingsContext.siteSettings.integ, trackingData);
    },

    loadEventDateInfo(eventDateID) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.setState({ loadingProductInfo: true });

        useAddTicketsToCartStore.getState().loadEventDate(eventDateID);

        // _this.eventDateInfosRequest = tsapp.mvcapi.postCtl("buyticket/eventdateinfos", { eventDateID: eventDateID }, { cache: false })
        //                                     .success(function (data) {
        //                                         tsapp.setCurrency(data.EventDateInfo.CurrencyCode);

        //                                         /*
        //                                         const showNewSale = useNewSale(data.EventDateInfo) && data.EventDateInfo.IsInSale;
        //                                         let step = "SELECTTICKET";
        //                                         if(showNewSale) 
        //                                             step = "SELECTPRICE";
        //                                         */ 
        //                                         _this.setState({
        //                                             currentStep: "SELECTTICKET",
        //                                             eventDate: data.EventDateInfo,
        //                                             loadingProductInfo: false
        //                                         });
        //                                         if (clientTracking != undefined) {
        //                                             const trackingData = {
        //                                                 type: 'itemSelected',
        //                                                 currency: data.EventDateInfo.CurrencyCode,
        //                                                 items: [
        //                                                     {
        //                                                         name: data.EventDateInfo.ProductNameFr,
        //                                                         code: data.EventDateInfo.EventDateCode,
        //                                                         producerName: data.EventDateInfo.ProducerName,
        //                                                         category: data.EventDateInfo.CategoryFr, // I hardcode FR here because we want it to be easy to group in analytics reports.
        //                                                         quantity: 1
        //                                                     }
        //                                                 ]
        //                                             };
                                                    
        //                                             clientTracking.trackEcommerceEvent(_this.props.integ, trackingData);
        //                                         }
        //                                     }.bind(_this))
        //                                     .notSuccess(function(data){
        //                                         _this.setState({loadingProductInfo:false, currentError:data.message});
        //                                         _this.raiseContentChanged();
        //                                     }.bind(_this));
    },

    loadSiteInformation(){
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.siteInfoProm = tsRest.get("/integration/" + _this.siteSettingsContext.siteSettings.integ + "/siteinfo")
                                    .done((info) => {
                                        _this.setState({ siteInfo: info });
                                    });
        
    },

    handleReturnToDateSelection () {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.setState({ eventDateID: null, currentStep:"SELECTDATE" });
    },

    handleReturnToTicketQtySelection () {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.setState({ currentStep:"SELECTTICKET" });
    },

    handleReturnToRangeSelection () {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.setState({ currentStep:"SELECTTICKET" });
        _this.setState({ scheduleRange: null });
    },

    onProductAddedToCart(placeToGo) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        switch(placeToGo) {
            case PlaceToGoEnum.CONTINUE_SHOPPING:
                _this.goToHome();
                break;
            case PlaceToGoEnum.GO_TO_CHECKOUT:
                _this.goToCheckout();
                break;
            case PlaceToGoEnum.GO_TO_CART:
                _this.goToCart();
                break;
        }
    },

    goToCart() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        tsapp.goToCart(_this.siteSettingsContext.siteSettings.integ);
    },

    goToCheckout() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        tsapp.goToCheckout(_this.siteSettingsContext.siteSettings.integ);

        //_this.urlsProm.done((urls) => { // Depends on the urls!
        //    if(urls.CheckoutUrl != null)
        //        parent.location.href = urls.CheckoutUrl; // We should have a promise of those URL instead... _this is a bit unsafe even though it may never crash.
        //    else
        //        window.location.href = "../ordervalidation/OrderValidationWidget";
        //});
    },

    goToHome() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        tsapp.goToHome(_this.siteSettingsContext.siteSettings.integ, _this.props.continueShoppingUrl);
    },

    setReturnToPackageUrl() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        // TOCHECK on set le packageurl empty parce qu'on ne ferait pas tout le menage pour le moment mais il n'est plus utilisé (voir BuildSeePromoLink dans IS2 .net)
        _this.setState({ packageUrl: "" });
        //tsapp.getPackageUrl(_this.props.integ).then((url) =>  _this.setState({ packageUrl: url }));
    },

    //TODO: Add other redirect here and pass them to the controls!


    handlePromoUpdated() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        if(_this.props.programID != null) {
            _this.loadProgramItemInfos();
            _this.promoEventDateUpdated();
        } else if(_this.props.eventDateID != null || _this.state.eventDate != null) {
            _this.loadEventDateInfo(_this.props.eventDateID != null ? _this.props.eventDateID : _this.state.eventDate.EventDateID);
        } else if(_this.props.eventID != null) {
            _this.loadEventItemInfos(_this.props.eventID);
        }
    },


    promoEventDateUpdated() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        const dateSelected = steps.indexOf(_this.state.currentStep) > steps.indexOf("SELECTDATE");
        
        if(dateSelected) {
            _this.loadEventDateInfo(_this.state.eventDateID);
        }
    },

    onFindTicketsWhenNoPrice(autoFindTicket: AutoFindTicketModel) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        
        // Trouver la section suivante!
        if(_this.state.eventDate.Sections.length > 0) {
            const currentSectionIndex = findIndex(_this.state.eventDate.Sections, { 'ID': autoFindTicket.sectionid });

            // On vérifie si on est pas rendu à la fin de la liste
            if(this.state.eventDate.Sections.length-1 > currentSectionIndex) {
                autoFindTicket.sectionid = _this.state.eventDate.Sections[currentSectionIndex + 1].ID;
            }
            else // si fin de liste on recommence au début
            {
                const firstSection = head(_this.state.eventDate.Sections) as Section;
                autoFindTicket.sectionid = firstSection.ID;
            }
        }
        
        useAddTicketsToCartStore.getState().setAutoFindTicket(autoFindTicket);

        _this.setState({ autoFindTicket: autoFindTicket, currentStep:"SELECTTICKET" });
    },

    handleOnMembershipPresaleClick(membershipTypeID: number, isInMembershipCardPreSaleAndHaveValidCard: boolean) {
        const _this: BuyTicketOnePagerWidgetInterface = this;

        if(!isInMembershipCardPreSaleAndHaveValidCard) {
            let membershipTypeIDs = [];
            membershipTypeIDs.push(membershipTypeID);

            _this.loadMembershipTypeSaleInfos(membershipTypeIDs);
        }
        else
        {
            _this.handleBuyOnClick();
        }
    },

    loadMembershipTypeSaleInfos(membershipTypeIDs) {
        const _this: BuyTicketOnePagerWidgetInterface = this;

        const membershipTypeSaleInfosLoadedReq = map(membershipTypeIDs, (membershipTypeID) =>
            tsRest.get("membershiptypes/" + membershipTypeID + "/saleinfo", { async: false }));

        Promise.all(membershipTypeSaleInfosLoadedReq)
            .finally(function() { _this.setState({processing:false}); }.bind(_this))
            .then(function(membershipInfos) {
                _this.setState({membershipTypeInfos: membershipInfos, showMembercardPopup:true});
            }.bind(_this), tsRest.handleError)
            .catch(function(err) {tsRest.handleError(err);});
    },

    handlePopupClose() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.setState({ showMembercardPopup: false });
    },

    handleSeeOurPromoOnClick(eventDate: EventDateInfo) {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        if (eventDate.Packages?.length > 1)
            _this.setState({ showPromoSelector: true });
        else if (eventDate.SeePromoLink != undefined && eventDate.SeePromoLink != "") //protection mais on aurait pas besoin vu que le valide avant d'afficher le bouton
            parent.location.href = eventDate.SeePromoLink;
    },
    
    handlePromoSelectorOnClose() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        _this.setState({showPromoSelector : false});
    },

    getLiteShopProductOverview(eventDate: EventDateInfo) {
        // const _this: BuyTicketOnePagerWidgetInterface = this;
        let date = null;
        if(eventDate.ProductType === "Ticket") {
            if(eventDate.EventHasNoSpecificDate)
                date = ""; 
            else if (eventDate.DateToBeDeterminated)
                date = tr("Date à déterminer");
            else
                date = getMomentTZDateTime(eventDate.Date, eventDate.TimeZone.TZDatabaseID).format(tr("program.format.moment.datetime"));
        }

        return date;
    },

    render() {
        const _this: BuyTicketOnePagerWidgetInterface = this;
        const programErrors = {
            "EVENTDATE_NOT_FOUND": tr("Aucune date disponible"),
            "EVENT_NOT_FOUND": tr("Aucune date disponible")
        };

        let errorMessage = null;
        let promoSection = null;
        let eventDate: EventDateInfo;
        let processing, dateChangeable, eventDateIDs, pleaseWaitMessage,
            dateSelected, dateSelectionSection,ticketQtySelected,
            productOverview,ticketQtySelectionSection,priceSelectionSection, eventSpecialInfo;

        if (_this.state.currentError != null)
        {
            errorMessage = <div className="container-fluid">
                <div className="alert alert-warning text-center">
                    <strong>{programErrors[_this.state.currentError]}</strong>
                </div>
            </div>;
        }
        else
        {
            processing = (_this.props.programID != null && _this.state.loadingProgram)
                        || (_this.props.eventID != null && _this.state.loadingProgram)
                        || (_this.props.eventDateID != null && _this.state.loadingProductInfo)
                        || (_this.props.rstprv != null && _this.state.loadingPromoInfo);

            dateChangeable = _this.props.programID != null || _this.props.eventID != null || _this.state.eventInfo != null; // Program Mode or Event Mode
            

            eventDateIDs = [];
            eventDateIDs.push(_this.state.eventDateID);
            eventDate = _this.state.eventDate;

            //TODO: Make sure this works as expected and maybe move it elsewhere (i.e not in render function)
            //eslint-disable-next-line react-hooks/rules-of-hooks, sonarjs/rules-of-hooks
            // Section - Please wait initial
            pleaseWaitMessage =
                (
                    processing
                    //(_this.props.programID != null && _this.state.program == null) // If in program mode and the program is not laoded
                    //|| (_this.props.programID == null && _this.state.eventDate == null) // If in event mode and the event is not loaded
                    //|| (_this.props.rstprv != null && _this.state.promoInfo == null) // If in event mode and the event is not loaded
                ) ? (
                    <PageSection>
                        <PleaseWaitSpinner size="md" />
                    </PageSection>
                )
                : null;

            // Cookie Issue Panel
            let cookieIssuePanel = null;
            if(_this.state.iframeCookieIssue
                && _this.state.siteInfo != null
                && _this.state.urlClientSite != null) { // Condition pour Affichage de l'activation des cookies
                cookieIssuePanel =
                    <PageSection>
                        <CookieSecurityWarningPanel
                            cookiesverified={true} // _this feature is not used anymore because we're using domains related with reservatech.net. It's true to bypass first step of validation.
                            tsSiteDomain="https://www.reservatech.net"
                            siteInfo={_this.state.siteInfo}
                            urlClientSite={_this.state.urlClientSite}
                        />
                    </PageSection>;
            }


            const hiddenPromo = (_this.props.rstprv != null && _this.props.rstprv != "");
            
            // Promo title and password
            const isInPromoMode = _this.state.promoInfo != null;
            const promoPasswordNeeded = isInPromoMode && _this.state.promoInfo.passwordNeeded;
            if(isInPromoMode) {
                if(_this.state.iframeCookieIssue) {
                    promoSection = cookieIssuePanel;
                } else {
                    promoSection =
                        <PageSection sectionDone={!promoPasswordNeeded}>
                            <PromoPasswordInputPanel
                                key="promoPasswordInputPanel"
                                promoInfo={_this.state.promoInfo}
                                onPromoInfoUpdated={_this.handlePromoInfoUpdated}
                                onContentChange={_this.props.onContentChange}
                            />
                        </PageSection>;
                }
            } 

            // Section - Event date selection (If applies)
            dateSelected = steps.indexOf(_this.state.currentStep) > steps.indexOf("SELECTDATE");
            if(!dateSelected &&
                (
                    _this.props.programID != null // In program mode
                    || _this.props.eventID != null) // Or in Event mode which is alike the program mode
            ) {
                if(_this.state.program != null) { // Here the program is not only a program. It can be an emulated program from an event
                    const programDates = map(_this.state.program.items, "EventDateInfo");
                    const selectedProgramDate = find(programDates, ['EventDateID', _this.state.eventDateID]);

                    // Protection si evenement pas en vente
                    if(selectedProgramDate && (!selectedProgramDate.IsInSale || selectedProgramDate.IsSoldOut) && _this.state.showMembercardPopup) {

                        dateSelectionSection = (
                            <PageSection sectionDone={false}>
                                <div className="col-xs-12 col-sm-offset-2 col-sm-8">
                                    <div className="well">
                                        <MembershipCardPickupControl membershipTypeInfos={_this.state.membershipTypeInfos}
                                            refreshActiveMembershipCards={() => _this.handleOnBuyClick()}
                                            onContentChange={_this.props.onContentChange}
                                            showAlreadyMemberSection={true}/>
                                        </div>
                                </div>
                            </PageSection>);
                    }
                    else
                        dateSelectionSection = (
                            <PageSection sectionDone={false}>
                                <ProgramInfo
                                    programID={_this.props.programID}
                                    eventID={_this.props.eventID}
                                    eventDateInfos={programDates}
                                    selectedEventDate={selectedProgramDate}
                                    prices={_this.state.program.prices}
                                    onContentChange={_this.props.onContentChange}
                                    onBuyClick={_this.handleOnBuyClick}
                                    onChangeEventDate={_this.handleOnChangeEventDate}
                                    loadingProductInfo={_this.state.loadingProductInfo}
                                    returnToPackageUrl={_this.state.packageUrl}
                                    onPromoUpdated={_this.handlePromoUpdated}
                                    onMembershipPresaleClick={_this.handleOnMembershipPresaleClick}
                                    hiddenPromo={hiddenPromo}
                                    integ={_this.siteSettingsContext.siteSettings.integ}
                                />
                            </PageSection>
                        ); 
                }
            }
            
            if(_this.state.eventInfo != null && !dateSelected) {
                let eventDates = _this.state.eventInfo.EventDateInfos;
                const selectedDate = find(eventDates, ['EventDateID', _this.state.eventDateID]);

                // If there an active promo, filter the dates that are not part of it.
                if(_this.state.promoInfo != null && _this.state.promoInfo.eventDateIDs.length > 0)  // If 0, then we show everything. That's the way it works in the presale system
                    eventDates = filter(eventDates, (ed) => includes(_this.state.promoInfo.eventDateIDs, ed.EventDateID));

                // TODO: Filtre des dates affichées
                dateSelectionSection = (
                    <PageSection sectionDone={false}>
                        <EventInfo
                            key="eventItems"
                            eventID={_this.state.eventInfo.ID}
                            eventDateInfos={eventDates}
                            selectedEventDate={selectedDate}
                            onContentChange={_this.props.onContentChange}
                            onBuyClick={_this.handleOnBuyClick}
                            onChangeEventDate={_this.handleOnChangeEventDate}
                            onMembershipPresaleClick={_this.handleOnMembershipPresaleClick}
                            loadingProductInfo={_this.state.loadingProductInfo}
                            onPromoUpdated={_this.handlePromoUpdated}
                            hiddenPromo={hiddenPromo}
                            integ={_this.siteSettingsContext.siteSettings.integ}
                        />
                    </PageSection>
                );            
            }

            // Section - Section and Ticket QTY selection **************************************************
            // *********************************************************************************************
            ticketQtySelected = steps.indexOf(_this.state.currentStep) > steps.indexOf("SELECTTICKET");
            if (dateSelected && eventDate != null) {
                const shouldDisplayChangeButton = (!eventDate.EventHasNoSpecificDate 
                                                && !eventDate.DateToBeDeterminated
                                                && (_this.state.program != null && _this.state.program.items.length > 1));

                productOverview = <>
                        {
                            tsapp.isLiteShop 
                                ? <LiteShopProductOverview
                                    pictureThumbnailURL={eventDate.MediaInfo.PictureThumbnailURL}
                                    productName={eventDate.ProductName}
                                    productDate={_this.getLiteShopProductOverview(eventDate)}
                                    productDescription={eventDate.Description}
                                    venueName={eventDate.VenueName}
                                />
                                : <PageSection sectionDone={true}>
                                    <ProductOverview
                                    product={eventDate}
                                    onModifyThisStep={dateChangeable ? _this.handleReturnToDateSelection : null}
                                    onContentChange={_this.props.onContentChange}
                                    onMembershipPresaleClick={_this.handleOnMembershipPresaleClick}
                                    shouldDisplayChangeButton={shouldDisplayChangeButton}
                                />
                            </PageSection>
                        }
                        {
                            _this.state.scheduleRange != null && <PageSection sectionDone={true}>
                                <div className="row">
                                    <div className="col-xs-12 col-sm-8 col-sm-offset-2 text-center">
                                        <ScheduleRangeSelectorInfo
                                            eventDate={eventDate}
                                            scheduleRange={_this.state.scheduleRange}
                                            onModifyThisStep={_this.handleReturnToRangeSelection}
                                            buttonClasses="btn btn-default btn-xs"
                                            onContentChange={_this.props.onContentChange}
                                        />
                                    </div>
                                </div>
                            </PageSection>
                        }
                </>;

                // Protection si evenement pas en vente
                if(!eventDate.IsInSale || eventDate.IsSoldOut) {
                    if(_this.state.showMembercardPopup)
                    ticketQtySelectionSection = (
                        <PageSection sectionDone={false}>
                            <div className="col-xs-12 col-sm-offset-2 col-sm-8">
                                <div className="well">
                                    <MembershipCardPickupControl membershipTypeInfos={_this.state.membershipTypeInfos}
                                        refreshActiveMembershipCards={() => _this.handleOnBuyClick()}
                                        onContentChange={_this.props.onContentChange}
                                        showAlreadyMemberSection={true}/>
                                    </div>
                            </div>
                        </PageSection>);
                else
                    ticketQtySelectionSection = (
                        <PageSection sectionDone={false}>
                            <div className="col-xs-12 col-sm-offset-2 col-sm-8">
                                <SaleMessagesInfo eventDateInfo={eventDate} onMembershipPresaleClick={_this.handleOnMembershipPresaleClick} onContentChange={_this.props.onContentChange}></SaleMessagesInfo>
                            </div>
                        </PageSection>
                    );
                } else if(_this.state.iframeCookieIssue) { // Fix IFrame security issue if apply (Safari, IPhone, IPad...)
                    ticketQtySelectionSection = cookieIssuePanel;
                } else if(eventDate.ProductType == "PrepaidCard") {
                    ticketQtySelectionSection = (
                        <PageSection sectionDone={false}>
                            <PrepaidCardQtySelection
                                eventDateId={eventDate.EventDateID}
                                priceId={eventDate.ProductInfo.priceId}
                                suggestedAmounts={eventDate.ProductInfo.suggestedAmounts}
                                onNewCardAdded={_this.onProductAddedToCart}
                                onContentChange={_this.props.onContentChange}
                            />
                        </PageSection> 
                    );

                } else if(eventDate.ProductType == "MembershipCard") {
                    ticketQtySelectionSection = (
                        <PageSection sectionDone={false}>
                            <MembershipCardPurchaseButtons
                                eventDateID={eventDate.EventDateID}
                                priceGroups={eventDate.MembershipTypeSaleInfo.priceGroups}
                                promoInfo={eventDate.PromoInfo}
                                onPromoUpdated={_this.handlePromoUpdated}
                                onNewCardAdded={_this.onProductAddedToCart}
                                onContentChange={_this.props.onContentChange}
                            />
                        </PageSection>
                    );

                } else if (eventDate.HasScheduleRangeSettings && _this.state.scheduleRange == null) {
                    ticketQtySelectionSection = (
                        <PageSection sectionDone={false}>  
                            <div className="row">
                                <div className="col-xs-12 text-center form-inline">                 
                                    <ScheduleRangeSelector
                                        eventDate={eventDate}
                                        sellerId={tsapp.user.ui}
                                        onChangeScheduleRange={_this.handleOnChangeScheduleRange}
                                        alertMessageClasses="alert alert-danger"
                                        comboClasses="form-control"
                                        onContentChange={_this.props.onContentChange}
                                    />
                                </div>
                            </div>
                        </PageSection>
                    );

                } else {
                    let scheduleRange = null;
                    if (_this.state.scheduleRange){
                        scheduleRange =                             
                            {
                                'maxNumberOfTicketsPerRange': _this.state.scheduleRange.MaxNumberOfTicketsPerRange,
                                'transactionTag': _this.state.scheduleRange.TransactionTag
                            };
                    }

                    let specialMessage;

                    if (eventDate.ImportantInfo)
                        specialMessage = <div className="specialMessage">
                            <div className="alert alert-warning" role="alert"><MarkDown source={eventDate.ImportantInfo}></MarkDown></div>
                        </div>;

                    const hasPackages = ((eventDate.SeePromoLink && eventDate.SeePromoLink != "") || (eventDate.Packages?.length > 0));

                    eventSpecialInfo = hasPackages && <PageSection sectionDone={true}>
                        {_this.state.showPromoSelector && <PromoSelectorButtons 
                            container={_this.packagePromoContainerRef.current}
                            packages={eventDate.Packages} 
                            onClose={_this.handlePromoSelectorOnClose} 
                        />}

                        <div ref={_this.packagePromoContainerRef}></div>
                        <div className="text-center">
                            <button 
                                type="button" 
                                className="btn btn-default text-uppercase btn-xs-mobile" 
                                onClick={() => _this.handleSeeOurPromoOnClick(eventDate)}
                            >
                                <span className="fa fa-tag" aria-hidden="true"/>
                                <span> {tsapp.trN("Voir notre promotion","Voir nos promotions", {n: (eventDate.Packages ? eventDate.Packages.length: 1)})}</span>
                            </button>
                        </div>
                        <br />
                    </PageSection>;

                    if(eventDate?.Use2024UnrestrictedSale) { 
                        ticketQtySelectionSection = <TicketSelectionUnrestricted />;
                    } else {
                        ticketQtySelectionSection = <TicketSelection
                            key="ticketSelection"
                            packageID={null}
                            eventDateIDs={eventDateIDs}
                            promoInfo={eventDate.PromoInfo}
                            onPromoUpdated={_this.handlePromoUpdated}
                            hiddenPromo={hiddenPromo}
                            productType={eventDate.ProductType}
                            overview={ticketQtySelected}
                            maxQty={4}
                            limitQtySales={_this.state.eventDate.LimitQtySales}
                            suggestedQtySales={_this.state.eventDate.SuggestedQtySales}
                            internetTicketQTYMultipleOf={_this.state.eventDate.InternetTicketQTYMultipleOf}
                            sections={eventDate.Sections}
                            autoFindTicket={_this.state.autoFindTicket}
                            forceSectionInPromo={eventDate.ForceSectionInPromo}
                            onContentChange={_this.props.onContentChange}
                            onFoundTickets={_this.handleOnFoundTickets}
                            onBuyClick={_this.handleOnBuyClick}
                            onModifyThisStep={_this.handleReturnToTicketQtySelection}
                            seePromoLink={eventDate.SeePromoLink}
                            packages={eventDate.Packages}
                            packageNumberForEventDate={eventDate.Packages.length}
                            scheduleRange={scheduleRange}
                            hideBestTicketSelection={_this.props.hideBestTicketSelection}
                            integ={_this.siteSettingsContext.siteSettings.integ}
                        />;
                    }
                    ticketQtySelectionSection = <PageSection sectionDone={ticketQtySelected}>
                        {specialMessage}
                        {ticketQtySelectionSection}
                    </PageSection>;
                }
            }

            // Section - Price group selection\
            if(ticketQtySelected)  {
                priceSelectionSection = (
                    <PageSection sectionDone={false} afterGetPosition={_this.afterGetPositionControl}>
                            <TicketPriceSelection
                                key="ticketPriceSelection"
                                packageID={null}
                                integ={_this.siteSettingsContext.siteSettings.integ}
                                eventDateIDs={eventDateIDs}
                                onContentChange={_this.props.onContentChange}
                                onProductAddedToCart={_this.onProductAddedToCart}
                                onFindTicketsWhenNoPrice={_this.onFindTicketsWhenNoPrice}
                            />
                    </PageSection>
                );
            }
        }

        const mainDivStyle = { minHeight: _this.state.minHeight };
        return <SiteCustomizationContext.Provider value={this.siteSettingsContext}>
            <CacheStoreContext.Provider value={cacheStore}>
                <IFrameContext.Provider value={_this.iframeContext}>
                    <div className={cIf(_this.siteSettingsContext?.siteSettings.integ)} style={mainDivStyle}>
                        {pleaseWaitMessage}
                        {promoSection}
                        {dateSelectionSection}
                        {productOverview}
                        {eventSpecialInfo}
                        {ticketQtySelectionSection}
                        {priceSelectionSection}
                        {errorMessage}
                    </div>
                </IFrameContext.Provider>
            </CacheStoreContext.Provider>
        </SiteCustomizationContext.Provider>;
    }
};
export const BuyTicketOnePagerWidget = createClass<BuyTicketOnePagerWidgetProps, BuyTicketOnePagerWidgetState>(BuyTicketOnePagerWidgetDef as any);


// function useNewSale(eventDate: EventDateInfo) {
//     return eventDate !== null 
//         && eventDate.Use2024UnrestrictedSale 
//         && eventDate.ProductType == ProductType.Ticket;
// }


// Params: item: ProgramID
// TODO: Make this control work with the POS instead of the ProgramID so we take the full advantage of the client's browser cache.
